const projectsArrays = [
  {
    id: "1",
    img: "1.PNG",
    modalPic: "pimentels-modal.PNG",
    frameworks: "HTML/CSS, Bootstrap, AOS",
    description:
      "Landscaping business that showcases all of their services, contact form and gallery of before and afters. I Utilize AOS library to for animations.",
    url: "https://pimentelslandscaping.com/",
  },
  {
    id: "2",
    img: "5.PNG",
    modalPic: "hiking-modal.PNG",
    frameworks:
      "Javascript, React.js, Node.js, React-Bootstrap, Stripe, Framer-Motion",
    description:
      "Ecomerce business that sells pet supplies. I Utilize Stripe in the back end to handle payment methods and React in the front end. Also Framer-Motion for animations.",
    url: "https://www.hikingpawz.com/",
  },
  {
    id: "3",
    img: "3.PNG",
    modalPic: "matchem-modal.PNG",
    frameworks: "Swift, SpriteKit",
    description:
      "A highly engaging iOS video game developed using Swift and the SpriteKit framework.",
    url: "https://apps.apple.com/us/app/matchem-shape-color/id1622708251",
  },
  {
    id: "4",
    img: "4.PNG",
    modalPic: "teamup-modal.PNG",
    frameworks: "Swift, Core Data",
    description:
      "IOS App makes the role of captaincy much simpler. I Utilize Core Data framework to store sports and players for each sport/occasion.",
    url: "https://apps.apple.com/us/app/team-up-teams/id1618447199",
  },
  {
    id: "5",
    img: "2.PNG",
    modalPic: "remind-modal.PNG",
    frameworks: "Swift, Core Data",
    description:
      "Location and Time based IOS Reminders App. I Utilize Core Data framework to store all users reminders.",
    url: "https://apps.apple.com/us/app/remind-me-reminders/id1617564386",
  },
  {
    id: "6",
    img: "6.PNG",
    modalPic: "bryan-develops-modal.PNG",
    frameworks: "Javascript, React.js, React-Bootstrap, Spline, Framer-Motion",
    description:
      "Web development freelance service. I Utilize Spline for 3D elements, framer motion for animations and built in React.js.",
    url: "https://bryandevelops.com/",
  },
  {
    id: "7",
    img: "7.PNG",
    modalPic: "pgu-modal.PNG",
    frameworks:
      "HTML/CSS, Javascript, React.js, Node.js, Express, Bootstrap, Framer-Motion",
    description:
      "QR code generator, easy to use and fun, type in any URL and convert it to a QR code. Free to downlad.",
    url: "https://apps.apple.com/us/app/point-guard-u/id6478332149",
  },
  {
    id: "8",
    img: "qrme-logo.png",
    modalPic: "qrme-modal.PNG",
    frameworks:
      "HTML/CSS, Javascript, React.js, Node.js, Express, Bootstrap, Framer-Motion",
    description:
      "QR code generator, easy to use and fun, type in any URL and convert it to a QR code. Free to downlad.",
    url: "https://guarded-bastion-42461-efeb749a8d2b.herokuapp.com/",
  },
];

export default projectsArrays;
